<template>
  <v-dialog
    v-model="dialogLocal"
    max-width="450px"
    persistent
  >
    <v-card>
      <v-card-title class="headline-custom" style="font-size: 1.3rem !important">
        Escolha o arquivo CSV para download
      </v-card-title>
      <v-card-text style="font-size: 15px !important">
        <v-select
          v-model="csv"
          :items="['CSV PADRÃO', 'CSV CUSTOMIZADO (ANEEL)']"
          label="Tipo de CSV"
          filled
        />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          text
          @click="dialogLocal = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          :disabled="!csv"
          @click="
            $emit('submitTriggered', tipoCSV),
            dialogLocal = false
          "
        >
          Baixar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true
    }
  },

   data: () => ({
    csv: null
  }),

  computed: {
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(newValue) {
        this.$emit('update:dialog', newValue);
      }
    },
    tipoCSV() {
      return this.csv == 'CSV CUSTOMIZADO (ANEEL)' ? 'csv-custom' : 'csv';
    }
  },
  
  watch: {
    dialogLocal(newVal) {
      if (newVal) this.csv = null;
    }
  }
}
</script>